export default __webpack_public_path__ + "static/media/acceZ.5fd11910.svg";